import * as types from './mutation-types'
import {cacheManager} from "@/services/cacheManagerjs";

export const loadMovements = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.get('get/stock/movements/collection')
            .then((response) => {
                commit(types.ADD_MOVEMENTS, response.data);
                resolve(response)
            })
            .catch((err) => {
                reject(err)
            })
    })
}

export const updateMovement = ({ commit }, data) => {

    return new Promise((resolve, reject) => {
        window.axios.patch('update/' + data.id + '/stock/movements', data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}


export const createMovement = ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post('store/stock/movements', data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}


export const showMovement = ({ commit }, id) => {
    return new Promise((resolve, reject) => {
        window.axios.get('get/' + id + '/stock/movements/detail').then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const downloadMovementPdf = ({ commit }, { id, type }) => {
    let endpoint = null

    if (type === 'ENTRY') endpoint = `get/${id}/stock/movements/entry/pdf`
    if (type === 'EXIT') endpoint = `get/${id}/stock/movements/exit/pdf`
    if (type === 'TRANSFER') endpoint = `get/${id}/stock/movements/delivery/pdf`

    if (!endpoint) {
        return Promise.reject(new Error('Invalid movement type'))
    }

    return new Promise((resolve, reject) => {
        window.axios.get(endpoint, { responseType: 'blob' }).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const loadTypeReasons = ({ commit, dispatch, state }, type) => {
    return new Promise((resolve, reject) => {
        cacheManager.fetch('get/stock/movement/reason?title='+type, state.reasons)
            .then((response) => {
                if(!response.fromState) commit(types.ADD_TYPE_REASONS, response.data);
                resolve(response)
            })
            .catch((err) => {
                reject(err)
            })
    })
}

export const loadMovementStatus = ({ commit, dispatch, state }) => {
    return new Promise((resolve, reject) => {
        cacheManager.fetch('get/movement/status/enum', state.movementStatus)
            .then((response) => {
                if(!response.fromState) commit(types.LOAD_MOVEMENT_STATUS, response.data);
                resolve(response)
            })
            .catch((err) => {
                reject(err)
            })
    })
}

export const loadMovementLineStatus = ({ commit, dispatch, state }) => {
    return new Promise((resolve, reject) => {
        cacheManager.fetch('get/line/status/enum', state.movementLineStatus)
            .then((response) => {
                if(!response.fromState) commit(types.LOAD_MOVEMENT_LINE_STATUS, response.data);
                resolve(response)
            })
            .catch((err) => {
                reject(err)
            })
    })
}

export const validateTransferMovement = ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post('validate/'+data.id+'/stock/movements', data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const sendMovement = ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post('submit/'+data.id+'/stock/movements', data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

